import { render } from "./SearchPermits.vue?vue&type=template&id=15ef113b"
import script from "./SearchPermits.vue?vue&type=script&lang=ts"
export * from "./SearchPermits.vue?vue&type=script&lang=ts"
script.render = render

export default script